import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  addNewPurchaseItemCategory,
  addNewPurchaseItemCategorySuccess,
  addNewPurchaseStatus,
  addNewPurchaseStatusSuccess,
  deletePurchaseItemCategory,
  deletePurchaseItemCategorySuccess,
  deletePurchaseStatus,
  deletePurchaseStatusSuccess,
  getPurchaseItemCategoryList,
  getPurchaseStatusList,
  updatePurchaseItemCategory,
  updatePurchaseItemCategorySuccess,
  updatePurchaseStatus,
  updatePurchaseStatusSuccess,
} from "../../../../store/purchase/action";
import {
  purchaseOrderStatusCreateRequest,
  purchaseOrderStatusCreateSuccess,
  purchaseOrderStatusDeleteRequest,
  purchaseOrderStatusDeleteSuccess,
  purchaseOrderStatusListGetRequest,
  purchaseOrderStatusUpdateRequest,
  purchaseOrderStatusUpdateSuccess,
} from "../../../../store/PurchaseOrder/action";
import PurchaseOrder from "../../../../store/PurchaseOrder/reducer";
export default function PurchaseOrderSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
    FlagCostOfGoodsSold: null,
  });

  const { purchaseStatusListAPI } = useSelector((state) => ({
    purchaseStatusListAPI:
      state.PurchaseOrder.purchaseOrderStatusList?.purchaseorderstatus_list,
  }));

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(purchaseOrderStatusCreateRequest([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = purchaseStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [purchaseStatusListAPI, activeTab]);

  const handleGetFreshData = () => {
    dispatch(purchaseOrderStatusListGetRequest());
  };
  useEffect(() => {
    handleGetFreshData();
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(purchaseOrderStatusDeleteRequest([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      ...(activeTab === "2" && {
        FlagCostOfGoodsSold: updateItemStatus?.FlagCostOfGoodsSold,
      }),
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(purchaseOrderStatusUpdateRequest([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  // Effects
  const {
    addNewPurchaseStatusSuccessAPI,
    deletePurchaseStatusSuccessAPI,
    updatePurchaseStatusSuccessAPI,
  } = useSelector((state) => ({
    addNewPurchaseStatusSuccessAPI:
      state.PurchaseOrder.purchaseOrderStatusCreate,
    deletePurchaseStatusSuccessAPI:
      state.PurchaseOrder.purchaseOrderStatusDelete,
    updatePurchaseStatusSuccessAPI:
      state.PurchaseOrder.purchaseOrderStatusUpdate,
  }));

  // Add New Status
  useEffect(() => {
    if (isEmpty(addNewPurchaseStatusSuccessAPI)) return;
    if (addNewPurchaseStatusSuccessAPI?.status === 200) {
      toast.success(addNewPurchaseStatusSuccessAPI?.message);
      handleGetFreshData();
    } else {
      toast.error(addNewPurchaseStatusSuccessAPI?.message);
    }
    dispatch(purchaseOrderStatusCreateSuccess([]));
  }, [addNewPurchaseStatusSuccessAPI]);

  // Delete Status
  useEffect(() => {
    if (isEmpty(deletePurchaseStatusSuccessAPI)) return;
    if (deletePurchaseStatusSuccessAPI?.status === 200) {
      toast.success(deletePurchaseStatusSuccessAPI?.message);
      handleGetFreshData();
      setDeleteModal(false);
    } else {
      toast.error(deletePurchaseStatusSuccessAPI?.message);
    }
    dispatch(purchaseOrderStatusDeleteSuccess([]));
  }, [deletePurchaseStatusSuccessAPI]);

  // Update Status
  useEffect(() => {
    if (isEmpty(updatePurchaseStatusSuccessAPI)) return;
    if (updatePurchaseStatusSuccessAPI?.status === 200) {
      toast.success(updatePurchaseStatusSuccessAPI?.message);
      handleGetFreshData();
    } else {
      toast.error(updatePurchaseStatusSuccessAPI?.message);
    }
    dispatch(purchaseOrderStatusUpdateSuccess([]));
  }, [updatePurchaseStatusSuccessAPI]);

  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Purchase Order Settings"
        description="Statuses for purchase orders."
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          costOfGoodsSold={activeTab === "2"}
        />
      </SettingsPanel>
    </>
  );
}
